'use strict';

var _ = require('lodash');
var FlattenedMarketCabinSposGroupTransformerFactory = function FlattenedMarketCabinSposGroupTransformerFactory(DataTransformer, momentService, configurationService, $filter, idService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function FlattenedMarketCabinSposGroupTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'rom-analysis-flattened-services-mode';
  }
  FlattenedMarketCabinSposGroupTransformer.prototype = Object.create(DataTransformer.prototype);
  FlattenedMarketCabinSposGroupTransformer.constructor = FlattenedMarketCabinSposGroupTransformer;
  FlattenedMarketCabinSposGroupTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  FlattenedMarketCabinSposGroupTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  FlattenedMarketCabinSposGroupTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlattenedMarketCabinSposGroupTransformer.prototype.transform = function (data) {
    var dataset = data.domain.flattenedMarketCabinSPOSOptList;
    var rtpRanges = configurationService.getParsedRTPS();
    _.forEach(dataset, function (record) {
      if (record.departureDateMoment) {
        return;
      }
      record.departureDate = record.romServices.departureDate;
      record.departureDateMoment = momentService.of(record.departureDate, momentService.FIELD.DEPARTURE_DATE);
      record.optGroupWeekMoment = momentService.of(record.optGroupWeek, momentService.FIELD.DEPARTURE_DATE);
      record.dow = rmMomentFormat(record.departureDateMoment, 'DAY_OF_WEEK').toUpperCase();
      record.service = idService.parseServiceId(record.romServices.serviceId);
      //in aggregation in metric keys (second argumant after data) will be ['individual'] or ['group'], so we can distinguish what data should be aggregated.
      //this approach should works for heat maps and trand opp. charts.
      record.spillPaxGap = {
        individual: getActualScenarioProp(record.romServices.idvResType, 'spill') - getMaxRevenueScenarioProp(record.romServices.idvResType, 'spill'),
        group: getActualScenarioProp(record.romServices.groupResType, 'spill') - getMaxRevenueScenarioProp(record.romServices.groupResType, 'spill')
      };
      record.recapPaxGap = {
        individual: getMaxRevenueScenarioProp(record.romServices.idvResType, 'recapture') - getActualScenarioProp(record.romServices.idvResType, 'recapture'),
        group: getMaxRevenueScenarioProp(record.romServices.groupResType, 'recapture') - getActualScenarioProp(record.romServices.groupResType, 'recapture')
      };
      record.spillRevGap = {
        individual: getActualScenarioProp(record.romServices.idvResType, 'spillRevenue') - getMaxRevenueScenarioProp(record.romServices.idvResType, 'spillRevenue'),
        group: getActualScenarioProp(record.romServices.groupResType, 'spillRevenue') - getMaxRevenueScenarioProp(record.romServices.groupResType, 'spillRevenue')
      };
      record.recapRevGap = {
        individual: getMaxRevenueScenarioProp(record.romServices.idvResType, 'recaptureRevenue') - getActualScenarioProp(record.romServices.idvResType, 'recaptureRevenue'),
        group: getMaxRevenueScenarioProp(record.romServices.groupResType, 'recaptureRevenue') - getActualScenarioProp(record.romServices.groupResType, 'recaptureRevenue')
      };
      record.departureTime = record.romServices.departureTime;
      record.potentialRevenue = {
        individual: getMaxRevenueScenarioProp(record.romServices.idvResType, 'revenue') - getActualScenarioProp(record.romServices.idvResType, 'revenue'),
        group: getMaxRevenueScenarioProp(record.romServices.groupResType, 'revenue') - getActualScenarioProp(record.romServices.groupResType, 'revenue')
      };
      record.daysToDeparture = rtpRanges[record.romTimeBucket - 1];
      record.isCodeShare = record.romServices.isCodeShare;
      record.isNonStop = record.romServices.isNonStop;
      record.romTimeBucket = record.romTimeBucket - 1;
      record.romServices = undefined;
      record.origin = undefined;
      record.destination = undefined;
      record.optGroupDate = undefined;
    });
    return dataset;
  };
  function getActualScenarioProp(resType, prop) {
    if (resType) {
      if (resType.actualScenario) {
        switch (prop) {
          case 'spill':
            return resType.actualScenario.spill;
          case 'recapture':
            return resType.actualScenario.recapture;
          case 'revenue':
            return resType.actualScenario.revenue;
          case 'spillRevenue':
            return resType.actualScenario.spillRevenue;
          case 'recaptureRevenue':
            return resType.actualScenario.recaptureRevenue;
          default:
        }
      }
    }
    return 0;
  }
  function getMaxRevenueScenarioProp(resType, prop) {
    if (resType) {
      if (resType.maxRevenueScenario) {
        switch (prop) {
          case 'spill':
            return resType.maxRevenueScenario.spill;
          case 'recapture':
            return resType.maxRevenueScenario.recapture;
          case 'revenue':
            return resType.maxRevenueScenario.revenue;
          case 'spillRevenue':
            return resType.maxRevenueScenario.spillRevenue;
          case 'recaptureRevenue':
            return resType.maxRevenueScenario.recaptureRevenue;
          default:
        }
      }
    }
    return 0;
  }
  return FlattenedMarketCabinSposGroupTransformer;
};
FlattenedMarketCabinSposGroupTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'ConfigurationService', '$filter', 'IdService'];
module.exports = FlattenedMarketCabinSposGroupTransformerFactory;